import 'bootstrap';
import $ from 'jquery';
import {showToastNotify, checkSymbols, TOASTR_ERROR, checkAmountRegexExp, checkAmountLengthRegexExp} from './helpers'
import { confirmAuthCode, needOperationConfirmAuthCode } from "./authConfirm";

const ERROR_INPUT_DATA = 'error-input-group',
      NON_VISIBLE = 'd-none',
      WITHDRAW_BTC_AMOUNT = $('#withdraw-btc-amount'),
      WITHDRAW_BTC_ADDR = $('#withdraw-btc-addr'),
      MIN_AMOUNT_VALUE_USD  = 50;

const WITHDRAW_BTC_AMOUNT_EMPTY_ERROR = $('#withdraw-btc-amount-empty-error'),
      WITHDRAW_BTC_ADDR_ERROR = $('#withdraw-btc-addr-error'),
      WITHDRAW_BTC_AMOUNT_MIN_ERROR = $('#withdraw-btc-amount-min-error'),
      WITHDRAW_BTC_AMOUNT_MAX_ERROR = $('#withdraw-btc-amount-max-error'),
      CONFIRM_WITHDRAW_BTC_ADDR = $('#confirm-withdraw-btc-address'),
      CONFIRM_WITHDRAW_BTC_AMOUNT = $('#confirm-withdraw-btc-amount'),
      CONFIRM_WITHDRAW_QUERY = $('#confirmWithdrawQuery'),
      WITHDRAW_MODAL = $('#withdraw'),
      WITHDRAW_MIN_USD_AMOUNT_VALUE = $('#withdraw-min-usd-amount-value'),
      WITHDRAW_MIN_BTC_AMOUNT_VALUE = $('#withdraw-min-btc-amount-value'),
      WITHDRAW_AMOUNT_TEXT = $('#withdraw-amount'),
      WITHDRAW_MIN_BTC_AMOUNT_TEXT = $('#withdraw-min-btc-amount-text'),
      CONFIRM_WITHDRAW_ACTION_BTN = $('#confirm-withdraw-action-btn');

const btcWithdraws = () => {
    const withdrawAmount = getWithdrawAmount()
    const btcAmount = WITHDRAW_BTC_AMOUNT;
    const btcAddress = WITHDRAW_BTC_ADDR;
    const btcAmountValue = btcAmount.val().replace(',', '.');
    const btcAddressValue = btcAddress.val();
    const maxWithdrawAmount = withdrawAmount['maxBtc']
    const minWithdrawAmount = withdrawAmount['minBtc']
    CONFIRM_WITHDRAW_ACTION_BTN.prop('disabled', false);
    if (!btcAmountValue || !btcAddressValue || (btcAmountValue > maxWithdrawAmount) || btcAmountValue <= 0
        || (btcAmountValue < minWithdrawAmount)) {
        if (!btcAmountValue) {
            btcAmount.addClass(ERROR_INPUT_DATA);
        }
        if (!btcAddressValue) {
            btcAddress.addClass(ERROR_INPUT_DATA);
            WITHDRAW_BTC_ADDR.removeClass(NON_VISIBLE)
        }
        if (btcAmountValue > maxWithdrawAmount) {
            btcAmount.addClass(ERROR_INPUT_DATA);
            WITHDRAW_BTC_AMOUNT_MAX_ERROR.removeClass(NON_VISIBLE)
        }
        if (btcAmountValue <= 0) {
            btcAmount.addClass(ERROR_INPUT_DATA);
            WITHDRAW_BTC_AMOUNT_EMPTY_ERROR.removeClass(NON_VISIBLE)
        }
        if (btcAmountValue < minWithdrawAmount) {
            btcAmount.addClass(ERROR_INPUT_DATA);
            WITHDRAW_BTC_AMOUNT_MIN_ERROR.removeClass(NON_VISIBLE)
            setErrorValueText();
        }
    } else {
        changeWithdrawData();
        CONFIRM_WITHDRAW_BTC_ADDR.text(btcAddressValue);
        CONFIRM_WITHDRAW_BTC_AMOUNT.text(btcAmountValue);
        WITHDRAW_MODAL.modal('hide');
        CONFIRM_WITHDRAW_QUERY.modal('show');
    }
}

const confirmWithdraw = (btn) => {
    btn.disabled = true;
    const needConfirmed = needOperationConfirmAuthCode();
    if (needConfirmed == 1) {
        confirmAuthCode('withdrawRequest');
    } else {
        sendWithdrawQuery();
    }
}

export const sendWithdrawQuery = () => {
    const btcAddr = CONFIRM_WITHDRAW_BTC_ADDR.text();
    const btcAmount = CONFIRM_WITHDRAW_BTC_AMOUNT.text();
    $.ajax({
        type: 'POST',
        url: '/btc-withdraw',
        data: {
            'btc_addr': btcAddr,
            'btc_amount': btcAmount,
        },
        success: function (result) {
            if (result) {
                let msg = 'Something wrong';
                if (result.msg) {
                    msg = result.msg;
                }
                if (!result.error) {
                    showWithdrawSuccess(result.amount, result.net_fee, result.addr, result.current_balance_amount);
                } else {
                    showToastNotify(TOASTR_ERROR, '', msg)
                }
            }
        }
    });
}

const setErrorValueText = () => {
    const withdrawAmount = getWithdrawAmount();
    const minBtc = withdrawAmount['minBtc']
    const minUsd = withdrawAmount['minUsd']
    WITHDRAW_MIN_USD_AMOUNT_VALUE.text(minUsd)
    WITHDRAW_MIN_BTC_AMOUNT_VALUE.text(minBtc)
}

const showWithdrawSuccess = (amountWithdraw, netFee, btcWithdraw, balanceAmount) => {
    CONFIRM_WITHDRAW_QUERY.modal('hide');
    $('#amount-withdraw').text(amountWithdraw);
    $('#withdraw-net-fee').text(netFee);
    $('#btc-withdraw').text(btcWithdraw);
    $('#balance-amount').text(balanceAmount);
    $('#withdrawSuccess').modal('show');
}

const hideWithdrawSuccess = () => {
    $('#withdrawSuccess').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

const hideWithdraw = () => {
    WITHDRAW_MODAL.on('hidden.bs.modal', function (e) {

    })
}

const getWithdrawAmount = () => {
    const maxBtc = parseFloat($('#max-btc').text().replace(',', '.'));
    const maxUsd = parseFloat($('#max-usd').text().replace(',', '.'));
    const minBtc = parseFloat($('#min-btc').text().replace(',', '.'));
    const minUsd = parseFloat($('#min-usd').text().replace(',', '.'));
    const minDefault = parseFloat($('#min-default').text().replace(',', '.'));

    return {
        'maxBtc': maxBtc,
        'maxUsd': maxUsd,
        'minBtc': minBtc,
        'minUsd': minUsd,
        'minDefault': minDefault,
    }
}

const setDefaultData = () => {
    const withdrawAmount = getWithdrawAmount();
    const maxBtc = withdrawAmount['maxBtc']
    const minBtc = withdrawAmount['minBtc']
    const minUsd = withdrawAmount['minUsd']
    const minDefault = withdrawAmount['minDefault']
    if (minUsd < MIN_AMOUNT_VALUE_USD) {
        WITHDRAW_BTC_AMOUNT.val(minBtc);
    }
    WITHDRAW_AMOUNT_TEXT.text(maxBtc);
    WITHDRAW_MIN_BTC_AMOUNT_TEXT.text(minDefault)
}

const openWithdrawModal = () => {
    setDefaultData();
    WITHDRAW_MODAL.modal('show');
}

const changeWithdrawData = () => {
    const btcAmountValue = WITHDRAW_BTC_AMOUNT.val().replace(',', '.');

    if (WITHDRAW_BTC_ADDR.hasClass(ERROR_INPUT_DATA)) {
        WITHDRAW_BTC_ADDR.removeClass(ERROR_INPUT_DATA);
    }
    if (WITHDRAW_BTC_AMOUNT.hasClass(ERROR_INPUT_DATA)) {
        WITHDRAW_BTC_AMOUNT.removeClass(ERROR_INPUT_DATA);
    }
    if (!WITHDRAW_BTC_ADDR_ERROR.hasClass(NON_VISIBLE)) {
        WITHDRAW_BTC_ADDR_ERROR.addClass(NON_VISIBLE);
    }
    if (!WITHDRAW_BTC_AMOUNT_EMPTY_ERROR.hasClass(NON_VISIBLE)) {
        WITHDRAW_BTC_AMOUNT_EMPTY_ERROR.addClass(NON_VISIBLE);
    }
    if (!WITHDRAW_BTC_AMOUNT_MAX_ERROR.hasClass(NON_VISIBLE)) {
        WITHDRAW_BTC_AMOUNT_MAX_ERROR.addClass(NON_VISIBLE);
    }
    if (!WITHDRAW_BTC_AMOUNT_MIN_ERROR.hasClass(NON_VISIBLE)) {
        WITHDRAW_BTC_AMOUNT_MIN_ERROR.addClass(NON_VISIBLE);
    }

    // const checkAmountRegexExp = /^([0]?)([.]?)([0-9]{1,}?)$/;
    // const checkAmountRegex = checkAmountRegexExp.exec(btcAmountValue)
    // if (checkAmountRegex) {
    //     if (!checkAmountRegex[2]) {
    //         const zeroPart = checkAmountRegex[1]
    //         if (zeroPart) {
    //             let fractionPart = checkAmountRegex[3]
    //             if (fractionPart.length > 8) {
    //                 fractionPart = fractionPart.slice(0,8);
    //             }
    //             const validBtcAmount = zeroPart + '.' + fractionPart
    //             WITHDRAW_BTC_AMOUNT.val(validBtcAmount);
    //         }
    //     }
    // }
    //
    // const checkAmountLengthRegexExp = /^([0-9]{1}?)([.]?)([0-9]{1,}?)$/;
    // const checkAmountLengthRegex = checkAmountLengthRegexExp.exec(WITHDRAW_BTC_AMOUNT.val())
    // if (checkAmountLengthRegex) {
    //     let fraction = checkAmountLengthRegex[3]
    //     const unit = checkAmountLengthRegex[1]
    //     const point = checkAmountLengthRegex[2]
    //     if (fraction.length > 8 && point) {
    //         const validFractionPart = fraction.slice(0,8);
    //         const validBtcLengthAmount = unit + point + validFractionPart
    //         WITHDRAW_BTC_AMOUNT.val(validBtcLengthAmount);
    //     }
    // }

    const checkAmountRegex = checkAmountRegexExp(btcAmountValue)
    if (checkAmountRegex) {
        WITHDRAW_BTC_AMOUNT.val(checkAmountRegex);
    }

    const checkAmountLengthRegex = checkAmountLengthRegexExp(WITHDRAW_BTC_AMOUNT.val())
    if (checkAmountLengthRegex) {
        WITHDRAW_BTC_AMOUNT.val(checkAmountLengthRegex);
    }
}

const changeWithdrawBtcAmount = () => {
    checkSymbols('withdraw-btc-amount');
    const btcAmount = WITHDRAW_BTC_AMOUNT;
    const btcAddress = WITHDRAW_BTC_ADDR;
    if (btcAddress.hasClass(ERROR_INPUT_DATA)) {
        btcAddress.removeClass(ERROR_INPUT_DATA);
    }
    if (btcAmount.hasClass(ERROR_INPUT_DATA)) {
        btcAmount.removeClass(ERROR_INPUT_DATA);
    }
}

const withdrawActiveFields = () => {
    $('#withdraw-btc-amount').focusin(function() {
        $('#withdraw-prepend-btc').addClass('info-background');
    });
    $('#withdraw-btc-amount').focusout(function() {
        $('#withdraw-prepend-btc').removeClass('info-background');
    });
}

function setMaxBtcAmount() {
    const withdrawAmount = getWithdrawAmount();
    const maxBtc = withdrawAmount['maxBtc']
    WITHDRAW_BTC_AMOUNT.val(maxBtc);
}

window.btcWithdraws = btcWithdraws;
window.confirmWithdraw = confirmWithdraw;
window.openWithdrawModal = openWithdrawModal;
window.changeWithdrawBtcAmount = changeWithdrawBtcAmount;
window.changeWithdrawData = changeWithdrawData;
window.setMaxBtcAmount = setMaxBtcAmount;

$(document).ready(() => {
    hideWithdrawSuccess();
    hideWithdraw();
    withdrawActiveFields();
});

